export default "__VITE_ASSET__BTY1Tyk9__"